import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUp, MessageCircle, Mail } from "lucide-react";
import { SITE } from "@/constants/site";

export default function FloatingButtons({ onOpenMail }) {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const onScroll = () => setShow(window.scrollY > 600);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <>
            {/* WhatsApp */}
            <motion.a
                href={SITE.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
                data-testid="float-whatsapp"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 1.6, duration: 0.6 }}
                className="fixed bottom-5 right-5 z-40 w-14 h-14 rounded-full bg-gold text-white flex items-center justify-center shadow-[0_15px_35px_-8px_rgba(201,162,39,0.6)] hover:bg-gold-deep transition-colors"
                style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
            >
                <span className="absolute inset-0 rounded-full bg-gold animate-ping opacity-30" />
                <MessageCircle className="w-6 h-6 relative z-10" />
            </motion.a>

            {/* Mail */}
            <motion.button
                onClick={onOpenMail}
                aria-label="E-Mail"
                data-testid="float-mail"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 1.7, duration: 0.6 }}
                className="fixed bottom-5 right-[5.5rem] z-40 w-14 h-14 rounded-full bg-white border border-gold/40 text-gold-deep flex items-center justify-center shadow-[0_15px_35px_-8px_rgba(201,162,39,0.35)] hover:border-gold hover:text-gold transition-colors"
            >
                <Mail className="w-6 h-6" />
            </motion.button>

            {/* Back to top */}
            <AnimatePresence>
                {show && (
                    <motion.button
                        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 20 }}
                        transition={{ duration: 0.4 }}
                        aria-label="Back to top"
                        data-testid="float-top"
                        className="fixed bottom-24 right-5 z-40 w-11 h-11 rounded-full bg-white border border-gold/40 text-ink flex items-center justify-center shadow-[0_10px_25px_-8px_rgba(0,0,0,0.15)] hover:border-gold hover:text-gold transition-colors"
                    >
                        <ArrowUp className="w-5 h-5" />
                    </motion.button>
                )}
            </AnimatePresence>
        </>
    );
}
